/** Escape text for safe inclusion in print HTML. */
export function escapeHtml(value) {
  if (value == null) return ''
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/**
 * Open the system print dialog for HTML content via a hidden same-origin iframe.
 * @param {string} html Full HTML document
 * @param {{ onError?: (message: string) => void }} [options]
 */
export function printHtmlDocument(html, options = {}) {
  const onError = options.onError || (() => {})
  const FRAME_ID = 'psg-print-html-frame'
  let frame = document.getElementById(FRAME_ID)
  if (frame) frame.remove()

  frame = document.createElement('iframe')
  frame.id = FRAME_ID
  frame.title = 'Print preview'
  frame.setAttribute('aria-hidden', 'true')
  Object.assign(frame.style, {
    position: 'fixed',
    right: '0',
    bottom: '0',
    width: '0',
    height: '0',
    border: '0',
    opacity: '0',
    pointerEvents: 'none',
  })
  document.body.appendChild(frame)

  const doc = frame.contentDocument || frame.contentWindow?.document
  if (!doc) {
    onError('Could not prepare the print view')
    frame.remove()
    return
  }
  doc.open()
  doc.write(html)
  doc.close()

  const runPrint = () => {
    try {
      frame.contentWindow?.focus()
      frame.contentWindow?.print()
    } catch (err) {
      onError(err?.message || 'Print failed')
    } finally {
      window.setTimeout(() => {
        try {
          frame.remove()
        } catch (_) {
          /* ignore */
        }
      }, 1000)
    }
  }

  const images = Array.from(doc.images || [])
  if (images.length === 0) {
    window.setTimeout(runPrint, 50)
    return
  }
  let pending = images.length
  let printed = false
  const maybePrint = () => {
    if (printed) return
    pending -= 1
    if (pending <= 0) {
      printed = true
      window.setTimeout(runPrint, 50)
    }
  }
  images.forEach((img) => {
    if (img.complete) maybePrint()
    else {
      img.addEventListener('load', maybePrint, { once: true })
      img.addEventListener('error', maybePrint, { once: true })
    }
  })
  window.setTimeout(() => {
    if (!printed) {
      printed = true
      runPrint()
    }
  }, 4000)
}
